<div class="textarea__container">
    <div class="textarea__container--label">
        <span class="textarea__container--label-name" *ngIf="!innerHTMLLabel">{{labelName}}</span>
        <span class="textarea__container--label-name" *ngIf="innerHTMLLabel" [innerHTML]="innerHTMLLabel"></span>
        <span *ngIf="isRequired" class="textarea__container--label-required">{{'custom_circuit_custom_fields_required' |
            translate}}</span>
    </div>
    <textarea [id]="id" [style.height.px]="inputHeight" [style.width.px]="inputWidth" matInput [maxLength]="maxLength"
        [minLength]="minLength" [disabled]="isDisabled" placeholder="{{placeholderName}}" [(ngModel)]="inputValue"
        [required]="isRequired" (input)="changeText()">
    </textarea>
    <div *ngIf="maxLength" [ngClass]="inputValue?.length === maxLength ? 'count-limit' : 'count'">
        {{ inputValue?.length ? inputValue.length : 0 }} / {{ maxLength }}
    </div>
</div>